import { render, staticRenderFns } from "./StudyNewPageScreeningQuestion.vue?vue&type=template&id=708f8ecc&scoped=true"
import script from "./StudyNewPageScreeningQuestion.vue?vue&type=script&lang=js"
export * from "./StudyNewPageScreeningQuestion.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageScreeningQuestion.vue?vue&type=style&index=0&id=708f8ecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f8ecc",
  null
  
)

export default component.exports